// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"98c1b884","348":"acff1017","558":"98e9c22b","571":"2337dcc6"}[chunkId] + ".chunk.js";
};